/* NION LIST COMPONENT ********************************************************/

import React, { Component, PropTypes } from 'react'
import {connect} from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* Utils */
import _ from 'lodash'

/* Components */
import NotificationItem from './item'

/* Widgets */
import SearchInput from 'widget/search-input'

/* Selectors */
import { getItems } from 'react-redux/selectors/notification'

/* Styles */
import "./list.css"

class NotificationList extends Component {

  /**
  * Show a Placeholder if no assets are available
  */
  renderPlaceholder() {
    const { filter, items, t } = this.props
    if (items.length) return null
    return <div className="placeholder">{ t("notification:list.empty") }</div>
  }

  /**
  * Render Asset Items as list elements
  */
  renderItems() {
    const { items } = this.props
    return (
      _.map(items, (item) => {
        return <NotificationItem
          listItem={ true }
          uid={ item.uid }
          key={ item.uid }
        />
      })
    )
  }

  render() {
    const { t, filter } = this.props
    return (
      <div className="notification-list component column-list">
        <div className="header">
          <h2>{ t("notification:list.headline") }</h2>
        </div>
        <div className="body">
          { this.renderPlaceholder() }
          <ul className="list">
            { this.renderItems() }
          </ul>
        </div>
      </div>
    )
  }
}

NotificationList.propTypes = {}

const mapStateToProps = (state) => {
  return {
    items: getItems(state),
    filter: state.notification.list.filter
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { },
    dispatch
  )
}

function mergeProps(stateProps, dispatchProps, ownProps){
  return Object.assign(
    stateProps,
    dispatchProps,
    ownProps
  )
}

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(NotificationList)
const translatedComponent = translate([], { withRef: true })(reduxComponent)
export default translatedComponent



// WEBPACK FOOTER //
// ./src/app/component/notification/list.jsx